import $ from 'jquery';
$(document).mouseup(function(e) {
  var container = $('.sidebar');
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    const currentClasses = e.target.classList;
    if (e.target.parentElement) {
      const currentParentClasses = e.target.parentElement.classList;
      if (
        !(currentClasses.contains('gjs-tablinks') || currentParentClasses.contains('gjs-tablinks'))
      ) {
        container.removeClass('selected');
      }
    }
  }
});

function setOSClass() {
  let userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'],
    os = null,
    rootClass = '';

  const rootElement = document.getElementById('root');

  if (rootElement) {
    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
      rootClass = 'mac';
      rootElement.classList.add('mac');
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
      rootClass = 'ios';
      rootElement.classList.add('ios');
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
      rootClass = 'win';
      rootElement.classList.add('win');
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
      rootClass = 'android';
      rootElement.classList.add('android');
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
      rootElement.classList.add('linux');
      rootClass = 'linux';
    }

    if (rootClass) {
      rootElement.classList.add(rootClass);
    }
  }

  return os;
}

setOSClass(); // Apply OS based class to the ROOT element
